import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import SSO from '../../utilities/sso';
import Api from '../Api';
import BodyCopy from './BodyCopy';
import { usePools } from '../DatabaseContext';
import Heading from './Heading';
import PrintButton from './PrintButton';

export default function History({ i18n }) {
    const { history, setHistory } = usePools()

    useEffect(async () => {
        if (SSO.getToken()) {
            const { data } = await Api.getHistory();

            setHistory(data)
        }
    }, [])

    if (!history.length) {
        return null
    }

    const deletePool = async pool => {
        const confirmed = confirm(i18n.history.deleteConfirm)

        if (!confirmed) {
            return;
        }

        const { data } = await Api.deletePool(pool.id);

        setHistory(data)
    }

    const buttons = pool => {
        return <div className="mt-4 sm:mt-0 sm:justify-end flex items-center space-x-6 pr-4">

            <Link to={`/${pool.id}/name`} className="flex items-center space-x-2 text-sm underline">
                <span><svg width="15" height="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg"><path d="M9.083 2.803l-9.07 9.07v3.075h3.075l9.07-9.07-3.075-3.075zM11.77 0a.96.96 0 00-.669.277L9.355 2.024l3.58 3.582 1.747-1.748a.951.951 0 000-1.346L12.449.277A.94.94 0 0011.771 0zM9.514 4.671l.776.775-7.634 7.634h-.775v-.775L9.514 4.67z" fill="currentColor" fillRule="evenodd"/></svg></span>
                <span>{ pool.printable ? i18n.history.edit : i18n.history.continue }</span>
            </Link>

            { pool.printable ? <PrintButton id={ pool.id }>
                <div className="flex items-center space-x-2 text-sm lin">
                    <svg width="19" height="18" viewBox="0 0 19 18" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor" fillRule="evenodd"><path d="M3.475 0v4.213H0V14.47h3.475V18h12.093v-3.531H19V4.213h-3.432V0H3.475zM4.56 4.213h9.922V1.111H4.56v3.102zM1.086 5.325h16.828v8.032h-2.346V9.843H3.475v3.514h-2.39V5.325zM4.56 16.888h9.922v-5.934H4.56v5.934z"/><path d="M14.25 8.526h1.9V6.632h-1.9zM6.65 13.263h5.7v-.947h-5.7zM6.65 15.158h5.7v-.947h-5.7z"/></g></svg>
                    <span className="underline">{ i18n.history.print }</span>
                </div>
            </PrintButton> : null }

            <button onClick={ () => deletePool(pool) } className="flex items-center space-x-2 text-sm underline hover:text-red-600">
                <span><svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" fillRule="evenodd" clipRule="evenodd"><path d="M19 24h-14c-1.104 0-2-.896-2-2v-17h-1v-2h6v-1.5c0-.827.673-1.5 1.5-1.5h5c.825 0 1.5.671 1.5 1.5v1.5h6v2h-1v17c0 1.104-.896 2-2 2zm0-19h-14v16.5c0 .276.224.5.5.5h13c.276 0 .5-.224.5-.5v-16.5zm-9 4c0-.552-.448-1-1-1s-1 .448-1 1v9c0 .552.448 1 1 1s1-.448 1-1v-9zm6 0c0-.552-.448-1-1-1s-1 .448-1 1v9c0 .552.448 1 1 1s1-.448 1-1v-9zm-2-7h-4v1h4v-1z"/></svg></span>
                <span>{ i18n.history.delete }</span>
            </button>
        </div>
    }

    return <div>
        <Heading>{ i18n.history.heading }</Heading>
        <BodyCopy className="mt-4">{ i18n.history.bodyCopy }</BodyCopy>

        <div className="mt-6 sm:hidden">
            {history.map((pool, index) =>
                <div className={`p-4 ${index % 2 === 0 ? 'bg-grey-50' : 'bg-white'}`} key={pool.id}>
                    <Link className="font-bold" to={`/${pool.id}/recommendations`}>
                        { pool.name }
                    </Link>
                    <div className="text-sm text-grey-500">
                        { new Date(pool.date).toLocaleDateString() }
                    </div>
                    { buttons(pool) }
                </div>,
            )}
        </div>

        <div className="mt-6 prose prose-lg max-w-full overflow-auto hidden sm:block">
            <div className="spreadsheet-container">
                <table className="w-full table-fixed">
                    <thead>
                        <tr>
                            <th><span className="pl-4">{ i18n.history.name }</span></th>
                            <th>{ i18n.history.date }</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {history.map((pool, index) =>
                            <tr className={index % 2 === 0 ? 'bg-grey-50' : 'bg-white'} key={pool.id}>
                                <td>
                                    <Link className="hover:underline pl-4" to={`/${pool.id}/recommendations`}>
                                        { pool.name }
                                    </Link>
                                </td>
                                <td>
                                    { new Date(pool.date).toLocaleDateString() }
                                </td>
                                <td>
                                    { buttons(pool) }
                                </td>
                            </tr>,
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
}
